function runHomepage() {
// ── Mobile menu ──────────────────────────────
const burger=document.getElementById('burgerBtn'),
      menu=document.getElementById('mobMenu'),
      overlay=document.getElementById('mobOverlay'),
      close=document.getElementById('mobClose');
function openMenu(){menu.classList.add('open');overlay.classList.add('open');burger.setAttribute('aria-expanded','true');document.body.style.overflow='hidden'}
function closeMenu(){menu.classList.remove('open');overlay.classList.remove('open');burger.setAttribute('aria-expanded','false');document.body.style.overflow=''}
burger.addEventListener('click',openMenu);
close.addEventListener('click',closeMenu);
overlay.addEventListener('click',closeMenu);

// ── Footer: desktop vs mobile mode ──────────
function initFooter(){
  const isMob=window.innerWidth<=860;
  for(let i=0;i<5;i++){
    const h=document.getElementById('dhead-'+i),
          l=document.getElementById('dlinks-'+i),
          btn=document.querySelector('[data-acc="'+i+'"]'),
          body=document.getElementById('acc-'+i);
    if(isMob){
      h.style.display='none';l.style.display='none';
      btn.style.display='flex';
    } else {
      h.style.display='block';l.style.display='flex';
      btn.style.display='none';body.classList.remove('open');
    }
  }
}
initFooter();
window.addEventListener('resize',initFooter);

// ── Footer accordion ─────────────────────────
document.querySelectorAll('.foot-acc-h').forEach(btn=>{
  btn.addEventListener('click',()=>{
    const idx=btn.dataset.acc,body=document.getElementById('acc-'+idx);
    const isOpen=body.classList.contains('open');
    document.querySelectorAll('.foot-acc-body').forEach(b=>b.classList.remove('open'));
    document.querySelectorAll('.foot-acc-plus').forEach(p=>p.style.transform='');
    if(!isOpen){body.classList.add('open');btn.querySelector('.foot-acc-plus').style.transform='rotate(45deg)'}
  });
});

// ── Before/After slider ──────────────────────
(function(){
  const wrap=document.getElementById('baWrap'),
        clip=document.getElementById('baClip'),
        line=document.getElementById('baLine'),
        knob=document.getElementById('baKnob');
  if(!wrap || !clip || !line || !knob) return;

  let drag=false;
  function set(x){
    const r=wrap.getBoundingClientRect();
    let p=Math.max(3,Math.min(97,((x-r.left)/r.width)*100));
    clip.style.clipPath='inset(0 '+(100-p)+'% 0 0)';
    line.style.left=p+'%';
  }

  if(window.PointerEvent){
    const start=e=>{
      drag=true;
      wrap.setPointerCapture?.(e.pointerId);
      set(e.clientX);
      e.preventDefault();
    };
    const move=e=>{ if(drag) set(e.clientX); };
    const stop=e=>{
      drag=false;
      wrap.releasePointerCapture?.(e.pointerId);
    };
    wrap.addEventListener('pointerdown',start);
    wrap.addEventListener('pointermove',move);
    wrap.addEventListener('pointerup',stop);
    wrap.addEventListener('pointercancel',stop);
    return;
  }

  wrap.addEventListener('mousedown',e=>{drag=true;set(e.clientX);e.preventDefault()});
  knob.addEventListener('mousedown',e=>{drag=true;e.preventDefault()});
  document.addEventListener('mouseup',()=>drag=false);
  document.addEventListener('mousemove',e=>{if(drag)set(e.clientX)});
  wrap.addEventListener('touchstart',e=>{drag=true;set(e.touches[0].clientX)},{passive:true});
  knob.addEventListener('touchstart',()=>drag=true,{passive:true});
  document.addEventListener('touchend',()=>drag=false);
  document.addEventListener('touchmove',e=>{if(drag)set(e.touches[0].clientX)},{passive:true});
})();

// ── Swatches ─────────────────────────────────
document.querySelectorAll('.sw').forEach(s=>s.addEventListener('click',()=>{
  document.querySelectorAll('.sw').forEach(x=>x.classList.remove('on'));s.classList.add('on')}));

// ── Scroll Reveal ─────────────────────────────
const io=new IntersectionObserver(entries=>entries.forEach(e=>{
  if(e.isIntersecting){e.target.classList.add('on');io.unobserve(e.target)}}),{threshold:.07});
document.querySelectorAll('.rev').forEach(el=>io.observe(el));

// ── Inspo scroll ──────────────────────────────
const nextBtn = document.getElementById('nextBtn');
const insScroll = document.getElementById('insScroll');
if (nextBtn && insScroll) {
  nextBtn.addEventListener('click', () => insScroll.scrollBy({ left: 240, behavior: 'smooth' }));
}

// ── Nav scroll effect ─────────────────────────
const navEl = document.querySelector('.nav');
window.addEventListener('scroll', () => {
  if(window.scrollY > 80) navEl.classList.add('scrolled');
  else navEl.classList.remove('scrolled');
}, {passive:true});

// ── Hero cinématique (léger parallax) ─────────
(function(){
  const heroBg = document.getElementById('heroBg');
  const hero = document.getElementById('home-hero');
  if(!heroBg || !hero || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let ticking = false;
  window.addEventListener('scroll', () => {
    if(ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const y = Math.min(window.scrollY, hero.offsetHeight) * 0.12;
      heroBg.style.transform = `scale(1.04) translateY(${y}px)`;
      ticking = false;
    });
  }, {passive:true});
})();

(function(){
  function initHeroVideoToggle(){
    var video = document.getElementById('heroVideo');
    var btn = document.getElementById('heroVideoToggle');
    if(!video || !btn) return;

    function refresh(){
      btn.innerHTML = video.paused ? '<span>▶</span>' : '<span>Ⅱ</span>';
      btn.setAttribute('aria-label', video.paused ? 'Relancer la vidéo' : 'Mettre la vidéo en pause');
    }

    btn.addEventListener('click', function(){
      if(video.paused){ video.play(); }
      else { video.pause(); }
      refresh();
    });

    video.addEventListener('play', refresh);
    video.addEventListener('pause', refresh);
    refresh();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initHeroVideoToggle);
  } else {
    initHeroVideoToggle();
  }
})();
}

if (document.documentElement.classList.contains('bio-preloader-active')) {
  document.addEventListener('bio:preloader:done', () => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runHomepage, { once: true });
    } else {
      runHomepage();
    }
  }, { once: true });
} else if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runHomepage);
} else {
  runHomepage();
}
